import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum';
import { RumProvider } from '@/logger/providers'
import {LogEntry, LogLevel} from '@/logger';

export class DatadogRumProvider implements RumProvider {
  constructor(private readonly config: RumInitConfiguration) {}

  initialize(): void {
    datadogRum.init(this.config);
  }

  send(entry: LogEntry): void {
    const rumContext = {
      timestamp: entry.timestamp,
      level: entry.level,
      ...entry.context
    }
    if ([
      LogLevel.ERROR,
      LogLevel.CRITICAL,
    ].includes(entry.level)) {
      const errorObject = entry.error instanceof Error ? entry.error : new Error(entry.message);
      datadogRum.addError(errorObject, {
        originalLogMessage: entry.message,
        ...rumContext
      });
    } else if ([
      LogLevel.DEBUG,
      LogLevel.INFO,
      LogLevel.WARN,
    ].includes(entry.level)) {
      datadogRum.addAction(entry.message, rumContext);
    }
  }
}
